import React from "react";
import { Box } from "@mui/material";
export default function NormalContainer({ children }) {
  return <Box sx={{ minWidth: 0 }}>{children}</Box>;
}
